import React from 'react'

import { Link } from 'gatsby'
import { BreadcrumbJsonLd } from 'gatsby-plugin-next-seo'

import { faAngleRight } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import './breadcrumbs.css'

export function Breadcrumbs(props: {
  breadcrumbs: {
    slug: string
    title: string
  }[]
}) {
  return (
    <div className="breadcrumbs">
      {props.breadcrumbs.map((breadcrumb, index) => {
        if (index === props.breadcrumbs.length - 1) {
          // It's the final breadcrumb
          return (
            // Nothing, because the page title should be an h1 below this
            <></>
          )
        }

        return (
          <>
            {' '}
            <Link to={breadcrumb.slug}>{breadcrumb.title}</Link>{' '}
            {/* An icon providing the > symbol */}
            <FontAwesomeIcon icon={faAngleRight} size="xs" />
          </>
        )
      })}

      {/* JSONLD */}
      {/* Only display if there's 2 or more breadcrumbs */}
      {/* https://developers.google.com/search/docs/appearance/structured-data/breadcrumb */}
      {props.breadcrumbs.length >= 2 ? (
        <BreadcrumbJsonLd
          itemListElements={props.breadcrumbs.map((breadcrumb, index) => ({
            position: index + 1,
            name: breadcrumb.title,
            item: `https://electricui.com${breadcrumb.slug}`,
          }))}
        />
      ) : null}
    </div>
  )
}